import { Button } from '@nesso/ui/primitives/button';

import { type EmailInUseError, formatEmailInUseMessage } from '@/entities/client';

type Props = {
    holder: EmailInUseError['holder'];
    isPending: boolean;
    onUseExisting: (holder: Extract<EmailInUseError['holder'], { kind: 'CLIENT' }>) => void;
};

export function AddClientFormEmailInUse({ holder, isPending, onUseExisting }: Props) {
    const { message, useExisting } = formatEmailInUseMessage(holder);

    return (
        <>
            {message}
            {' or '}
            {holder.kind === 'CLIENT' ? (
                <Button
                    type="button"
                    variant="inline-link"
                    disabled={isPending}
                    onClick={() => onUseExisting(holder)}
                >
                    {useExisting}
                </Button>
            ) : (
                useExisting
            )}
        </>
    );
}
